<template>
        <!-- <categoriesMenu :shopData="shopData" :allCategories="allCategories" :currentRouteName="currentRouteName" class="categoriesMenu" @categoryChange="categoryChange" /> -->
        <div class="listingPageWrapper" v-if="fetchDataListing && shippingProfileData && shopData">
            <div class="shape"></div>
            <div class="card flex justify-center" style="margin-top: -13px">
                <Breadcrumb :home="home" :model="items" style="background-color: transparent;">
                    <template #item="{ item, props }">
                        <router-link v-if="item.route" v-slot="{ href, navigate }" :to="item.route" custom>
                            <a :href="href" v-bind="props.action" @click="navigate">
                                <span :class="[item.icon, 'text-color']" />
                                <span class="text-primary font-semibold">{{ item.label }}</span>
                            </a>
                        </router-link>
                        <a v-else :href="item.url" :target="item.target" v-bind="props.action" style="cursor: pointer; text-transform: capitalize;">
                            <span class="text-surface-700 dark:text-surface-0">{{ item.label }}</span>
                        </a>
                    </template>
                </Breadcrumb>
            </div>
            <div class="listingBody">
                <div class="left-side">
                    <gallery 
                        :fetchDataListing="fetchDataListing" 
                        :shopData="shopData" 
                        :slides="slides" 
                    />
                    <div class="sellerInfo">
                        <sellerCard 
                            :fetchDataListing="fetchDataListing" 
                            :shopData="shopData"
                            @openContactPopup="$emit('openContactPopup')" 
                        />
                    </div>
                </div>

                <div class="right-side">
                    <div class="productDataWrapper">
                        <div class="mobileShape"></div>
                        <div class="listingTitle">
                            <meta name="description" :content="'productSku: '+fetchDataListing.sku" v-if="fetchDataListing.sku" />
                            <h1 class="productSku" id="product-code">Tootekood: <a v-if="fetchDataListing.sku" style="color: silver;">{{fetchDataListing.sku}}</a></h1>
                            <h2 class="title" v-if="fetchDataListing != undefined">{{fetchDataListing.title}}</h2>
                            <p class="price">{{round(fetchDataListing.price, 2)}}€</p>
    
                            <img 
                                v-if="!determineBrandLogo"
                                :src="require('@/assets/listing/siemens.png')" 
                                alt="logo"
                                width="140px"
                            />
                        </div>
                        <addToCart 
                            class="sticky"
                            @openCartSidebar="$emit('openCartSidebar')"
                            @logout="$emit('logout')"
                            :fetchDataListing="fetchDataListing"
                            :fetchDataShop="shopData"
                            :fetchLegalEntity="shopData.legalEntity"
                            :currentLang="currentLang"
                        />
                    </div>
                    <description :fetchDataListing="fetchDataListing" :shopData="shopData" />
                    <div class="sellerInfoMobile">
                        <sellerCard 
                            :fetchDataListing="fetchDataListing" 
                            :shopData="shopData"
                            @openContactPopup="$emit('openContactPopup')" 
                        />
                    </div>
                </div>
            </div>
        
            <!-- <div class="line"></div>
            <Carousel :value="listingData" :showNavigators="false" :numVisible="5" :numScroll="1" :autoplayInterval="15000" v-if="listingData.length > 4">
                <template #item="slotProps">
                    <productCard
                        class="viewCard"
                        @logout="$emit('logout')"
                        :listingData='slotProps.data'
                        :shopPage='true'
                        :waitTime="500"
                        :index="index"
                        @openCartSidebar="$emit('openCartSidebar')"
                    />
                </template>
            </Carousel> -->
        </div>
</template>

<script>
// import categoriesMenu from '../components/menus/categoriesMenu.vue'
import gallery from '../components/listing/gallery.vue';
import description from '../components/listing/description.vue';
import sellerCard from '../components/listing/sellerCard.vue';
import addToCart from '../components/listing/addToCart/addToCart.vue';
import Breadcrumb from 'primevue/breadcrumb';
// import Carousel from 'primevue/carousel';
// import productCard from '../components/shopLanding/productCard-small.vue'

import core from '@/api/index'

export default {
    name: 'listingPage',
    components: {
        // categoriesMenu,
        gallery,
        description,
        addToCart,
        Breadcrumb,
        sellerCard
        // productCard,
        // Carousel
    },
    props: {
        idShop: {},
        shopData: {},
        shopPageUrl: {},
        feedbacksData: {},
        feedbackStatsData: {},
        listingData: {},
        listingsDataRaw: {},
        cardLoadingTime: {},
        counter: {},
        shippingProfileData: {},
        allCategories: [],
        currentLang: String,
        currentRouteName: String
    },
    data() {
        return {
            catchError: null,
            isLoading: false,
            idListing: Number(this.$route.params.id),
            fetchDataListing: null,
            slides: [],
            home: {
                icon: 'pi pi-home',
                route: '/'
            },
            items: []
        };
    },
    methods: {
        round(num, decimalPlaces = 0) {
            num = Math.round(num + "e" + decimalPlaces);
            return Number(num + "e" + -decimalPlaces);
        },

        handleItemClick() {
            this.$emit('openCategoriesDrawer')
        },

        dataFetchListing: async function() {
            const secretLink = this.$route.query.secretLink
            const queryParams = secretLink ? { secretLink } : {}

            core.listingApi.getSingleListing({
                pathParam: this.idListing,
                queryParams: queryParams
            })
            .then((res) => {
                if(res.status == 'success') {
                    const respo = Object.values(res)
                    this.fetchDataListing = respo[1].listing

                    this.slides.push(this.$fetchIp+'/static/images/listings/'+this.fetchDataListing.coverImg)
                    for(const element of this.fetchDataListing.images) {
                        this.slides.push(this.$fetchIp+'/static/images/listings/'+element)
                    }
                    this.slides = this.slides.filter((value, index, array) => {
                        return array.indexOf(value) == index
                    })

                    this.items = [
                        { label: 'Kataloog', route: '/kataloog' },
                        {
                        label: this.fetchDataListing.listingTag?.translations?.et || 'Fallback',
                        command: this.handleItemClick
                        },
                        { label: 'Toode' }
                    ]
                }
                if(res.message == 'Access denied.') {
                    this.isLoading = false
                    this.$toast.add({ severity: 'warn', summary: 'Veateade', detail: 'Kuulutus ei ole avalikult kättesaadav!', life: 5000 });
                    this.$router.push('/')
                }
                if(res.message == 'Object does not exist that the access is requested for.') {
                    this.$toast.add({ severity: 'warn', summary: 'Veateade', detail: 'Kuulutus ei eksisteeri!', life: 5000 });
                }
            })
            .catch((err) => {
                this.catchError = err
            })      
        },
    },
    created() {
        this.dataFetchListing()
    },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap');
.p-carousel-item-list {
    padding: 0;
}
</style>
<style scoped>
.shape {
    position: absolute;
    right: -1315px;
    top: 42px;
    height: 470px;
    width: 1940px;
    background: rgb(240, 240, 240);
    border-radius: 20px;
    /* -webkit-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.15);
    -moz-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.15);
    box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.15); */
}
.categoriesMenu {
    position: sticky;
    top: -14px;
}
.listingPageWrapper {
    position: relative;
    padding-top: 0px;
    padding-bottom: 100px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    width: 1300px;
    margin: 0 auto;
}
.listingTitle {
    position: relative;
    text-align: left;
    width: 100%;
    margin-top: 15px;
}
.listingTitle img {
    position: absolute;
    bottom: -57px;
    right: 0;
}
.sectionTitle {
    color: rgb(150, 150, 150);
    font-size: 24px;
    font-family: 'Nunito', sans-serif;
    font-weight: 700;
    padding-bottom: 10px;
    margin-top: 29px;
}

.title {
    margin: 0;
    font-size: 1.6rem;
    color: rgb(25, 25, 25);
    font-weight: 400;
    width: 100%;
    font-family: "Inter", system-ui, ui-sans-serif, sans-serif;
    font-weight: 700;
    font-size: 30px;
}
.title:hover {
    color: rgb(25,25,25);
    cursor: pointer;
}
.listingTitle p {
    position: relative;
    width: 100%;
    margin: 0;
    margin-top: 15px;
    margin-bottom: 0px;
    font-size: 30px;
    font-weight: 700;
    color: #069599;
    font-family: "Inter", system-ui, ui-sans-serif, sans-serif;
}
.listingTitle span {
    position: absolute;
    right: 5px;
    font-weight: 400;
}
.listingTitle span:hover {
    color: #64C3A2;
    cursor: pointer;
}
.listingBody {
    position: relative;
    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}

.left-side {
    position: relative;
    width: 680px;
    margin-right: 60px;
}
.sellerInfo {
    margin-top: 80px;
}
.sellerInfoMobile {
    display: none;
}
.right-side {
    max-height: 100%; /* Ensures right-side doesn't exceed the height of its parent (body) */
    position: relative;
    top: 0px;
    width: 100%;
}
.productDataWrapper {
    position: relative;
    width: 100%;
    min-height: 470px;
}
.mobileShape {
    display: none;
    background: rgb(240,240,240);
    position: absolute;
    height: 100%;
    width: 120%;
    left: -20px;
    top: -10px;
}
.sticky {
    position: sticky;
    top: 100px; /* Adjust this value as needed */
    left: auto;
}
.line {
    height: 1px;
    width: 100%;
    border-top: 1px solid rgb(230,230,230);
    margin-bottom: 20px;
    margin-top: 20px;
}
.productSku {
    font-size: 16px;
    color: silver;
    font-weight: 400;
    margin-top: 0;
    
}
@media(max-width: 1350px) {
    .listingPageWrapper {
        width: 100%;
        padding-left: 20px;
        padding-right: 20px;
        margin-left: 0;
    }
    
}
@media(max-width: 370px) {
    .listingPageWrapper {
        width: 100%;
        padding-left: 15px;
        padding-right: 15px;
        margin-left: 0;
    }
    
}
@media(max-width: 1184px) {
    .title {
        font-size: 20px;
    }
    
}
/* @media(max-width: 1570px) {
    .left-side {
        position: relative;
    }
    .listingTitle {
    }
    .right-side {
    }
    
} */
@media(max-width: 800px) {
    .listingBody {
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
    }
    .shape {
        display: none;
    }
    .left-side {
        margin-right: 0;
        width: 100%;
    }
    .sellerInfo {
        display: none;
    }
    .sellerInfoMobile {
        display: initial;
    }
    .mobileShape {
        display: initial;
    }
    .right-side {
        margin-top: 30px;
    }
}
@media(max-width: 750px) {
    .listingPageWrapper {
        padding-bottom: 100px;
    }
    .title {
        width: 100%
    }
    
}
@media(max-width: 400px) {
    #removeShopName {
        display: none;
    }
    .title {
        font-size: 1.5rem;
    }
    
}
</style>
